import { render, staticRenderFns } from "./EnterProductInformation.vue?vue&type=template&id=548f1942"
import script from "./EnterProductInformation.vue?vue&type=script&lang=js"
export * from "./EnterProductInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports